export const ROUTE_LOGIN: string = '/login';
export const ROUTE_OKTA_LOGIN_CALLBACK: string = '/okta-login-callback';
export const ROUTE_REGISTRATION: string = '/registration';
export const ROUTE_FORGOT_PASSWORD: string = '/forgot-password';
export const ROUTE_PASSWORD_RECOVERY: string = '/password-recovery';
export const ROUTE_VERIFICATION: string = '/verification';
export const ROUTE_VERIFICATION_SETUP: string = '/verification-setup';
export const ROUTE_LOGOUT: string = '/logout';
export const ROUTE_DASHBOARD: string = '/';
export const ROUTE_SETTINGS: string = '/settings';
export const ROUTE_SETTINGS_ACCOUNT: string = '/settings-account';
export const ROUTE_SETTINGS_ACCOUNT_LIST: string = '/settings-account-list';
export const ROUTE_SETTINGS_OPERATION_LOG: string = '/settings-operation-log';
export const ROUTE_SETTINGS_DEAL_TEMPLATE_LIST: string = '/settings-deal-template-list';
export const ROUTE_SETTINGS_PORTFOLIO_GROUP_LIST: string = '/settings-portfolio-group-list';
export const ROUTE_SETTINGS_USER_LIST: string = '/settings-user-list';
export const ROUTE_SETTINGS_PROFILE: string = '/settings-profile';
export const ROUTE_SETTINGS_SECURITY: string = '/settings-security';
export const ROUTE_SETTINGS_NOTIFICATIONS: string = '/settings-notifications';
export const ROUTE_SEARCH: string = '/search';
export const ROUTE_ASSET_LIST: string = '/asset-list';
export const ROUTE_ACTIVITY_LIST: string = '/activity-list';
export const ROUTE_DEAL_LIST: string = '/deal-list';
export const ROUTE_CONTACT_LIST: string = '/contact-list';
export const ROUTE_REPORT_LIST: string = '/report-list';
export const ROUTE_NOT_FOUND: string = '/not-found';
export const ROUTE_ASSET: string = '/asset';
export const ROUTE_ACTIVITY: string = '/activity';
export const ROUTE_DEAL: string = '/deal';
export const ROUTE_CONTACT: string = '/contact';
export const ROUTE_REPORT: string = '/report';
export const ROUTE_USER: string = '/user';
export const ROUTE_PORTFOLIO_GROUP: string = '/portfolio-group';
export const ROUTE_PORTFOLIO: string = '/portfolio';
export const ROUTE_DEAL_TEMPLATE: string = '/deal-template';
export const ROUTE_CONTENT_ALL: string = '*';
export const ROUTE_ALL: string = '/*';
export const ROUTE_PARAM_ID: string = 'id';
export const ROUTE_PARAM_ID_NEW: string = 'new';
export const ROUTE_PARAM_HASH: string = 'hash';
